
// import { ref, onMounted } from 'vue'
import { reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import NewsLists from '@/components/block/NewsLists_OUTDATED.vue'
import Alert from '@/components/elements/Alert.vue'
import Pager from '@/components/block/Pager.vue'
import NewsArchive from '@/components/block/NewsArchive.vue'

import { axiosSetting } from '@/utils/axiosSetting'

export default {
  name: 'News',
  components: {
    HeadingLv1,
    NewsLists,
    Alert,
    Pager,
    NewsArchive
  },
  setup() {
    const state = reactive({
      loading: true
    })
    const lists = ref([])
    const totalPosts = ref(0)

    const route = useRoute()
    const router = useRouter()

    const ajax = axiosSetting('cms', 'block')

    const perPage = 20

    // console.log(route.name)
    const currentUrl: any = () => {
      if (route.name == 'News') {
        return `${process.env.VUE_APP_WPAPI_URL}wp-json/wp/v2/news?per_page=${perPage}`
      } else if (route.name == 'NewsPage') {
        return `${process.env.VUE_APP_WPAPI_URL}wp-json/wp/v2/news?per_page=${perPage}&page=${route.params.page}`
      }
    }

    const getLists = () => {
      ajax
        .get(currentUrl())
        .then((res) => {
          lists.value = res.data
          // console.log(res.headers)
          totalPosts.value = res.headers['x-wp-total']
        })
        .finally(() => {
          state.loading = false
        })
    }

    const movePage = (num: number) => {
      const path = route.path
      const regexp = /news\/\d*/g
      const matches = path.match(regexp)
      let nextPagePath = ''

      if (num > 1 && matches !== null)
        nextPagePath = path.replace(matches[0], `news/${num}`)

      if (num === 1 && matches !== null)
        // nextPagePath = path.replace(`/${matches[0]}`, '')
        nextPagePath = path.replace(matches[0], `news/${num}`)

      if (num > 1 && matches === null) nextPagePath = `${path}/${num}`

      if (num === 1 && matches === null) nextPagePath = path

      // 一旦リンクに変更
      // location.href = nextPagePath
      router.push(nextPagePath)
    }

    // onMounted(() => {
    //   getLists()
    // })

    // console.log(route.params.page)
    getLists()

    watch(
      // () => route.params.page,
      () => route.path,
      () => {
        // console.log(route.params.page,)
        getLists()
      }
    )

    return {
      state,
      lists,
      totalPosts,
      perPage,
      movePage
    }
  }
}
